import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDIcon,
  FDSecondaryActionButton,
  FDStack, FDTitleText, FDTooltip,
} from '@facet-wealth/design';
import { noop } from 'Helpers/PropTypes';
import PropTypes from 'prop-types';
import React from 'react';
import { makeStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import InsightEditor
  from 'Views/Page/Content/Templates/WhatIfProposalPreviewTemplate/MainContentPicker/MainContentForScenarioSelectionRedefined/ProposalInsightPicker/ProposalInsightContent/InsightLayout/InsightEditor';
import fr from 'facet-rest';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';

const useStyles = makeStyles(theme => ({
  divider: {
    border: 'none',
    backgroundColor: theme.palette.facet.lightGray2,
    height: '1px',
    width: '100%',
  },
}));

const InsightLayout = ({
  onSubmit,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const { resource } = useMetaLayoutContext();
  const {
    loadModalCollectionByLink,
  } = useModalContext();

  return (
    <FDStack direction={'column'} spacing={3}>
      <FDStack direction={'row'} justifyContent={'space-between'}>
        <FDStack direction={'row'} spacing={1} alignItems={'center'}>
          <FDTitleText value={resource.attr('title')} size={'lg'} color={'textSecondary'} />
          {resource.attr('hintNotes') && (
          <FDTooltip title={resource.attr('hintNotes')}>
            <FDIcon icon={'info'} color={'primary'} />
          </FDTooltip>
          )}
        </FDStack>
        {resource.withRelationship(fr.relationships.plannerGuide.name,
          (rel) => {
            return (<FDSecondaryActionButton
              label={rel.meta('prompt')}
              size={'sm'}
              onClick={() => loadModalCollectionByLink(rel.link('related').url())}
            />);
          },
          () => null)}
      </FDStack>
      <MetaControlField attr={'subtitle'} />
      <InsightEditor onSubmit={onSubmit} />
      <hr className={classes.divider} />
    </FDStack>
  );
};

InsightLayout.defaultProps = {
  onSubmit: noop,
};

InsightLayout.propTypes = {
  onSubmit: PropTypes.func,
};

export default InsightLayout;
